import React from "react";
import _Input from "../../generic/_Input";
import _Select from "../../generic/_Select";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import TotalAudience from "../TotalAudience";
const GeneralData = ({ step = 1 }) => {
  const { values, handleChange, errors, handleBlur } = useFormikContext();
  const {
    listDatabases,
    campaignName,
    uiddatabase,
    mask,
    listMask,
    partnerList,
    partner,
    customersList,
    id_customer,
  } = values;
  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="flex items-end gap-2">
        <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
          <span className="font-bold">{step}</span>
        </div>
        <div className="text-xl font-bold text-gray-600">Datos Generales</div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="flex flex-col py-2">
          <_Input
            title="Nombre de la Campaña"
            name="campaignName"
            id="campaignName"
            type="text"
            value={campaignName}
            onChange={handleChange}
            placeholder="Ejemplo: Promoción de Verano"
            onBlur={handleBlur}
            errors={errors && errors.campaignName}
            isError={errors && errors.campaignName ? true : false}
            required
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col py-2">
          <_Select
            title="Cliente"
            required
            name="id_customer"
            id="id_customer"
            value={id_customer}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.id_customer}
            isError={errors && errors.id_customer ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...customersList.map((item) => ({
                value: item.idcustomer,
                label: item.comercialname,
              })),
            ]}
          />
        </div>
        <div className="flex flex-col py-2">
          <_Select
            title="Partner"
            required
            name="partner"
            id="partner"
            value={partner}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.partner}
            isError={errors && errors.partner ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...partnerList.map((item) => ({
                value: item.uidpartner,
                label: item.name,
              })),
            ]}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col py-2">
          <_Select
            title="Base de Datos"
            required
            name="uiddatabase"
            id="uiddatabase"
            value={uiddatabase}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.uiddatabase}
            isError={errors && errors.uiddatabase ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...listDatabases.map((item) => ({
                value: item.uiddatabase,
                label: item.name,
              })),
            ]}
          />
        </div>
        <div className="flex flex-col py-2">
          <_Select
            title="Máscara"
            name="mask"
            id="mask"
            value={mask}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors && errors.mask}
            isError={errors && errors.mask ? true : false}
            options={[
              {
                value: "",
                label: "Selecciona de la lista",
              },
              ...listMask.map((item) => ({
                value: item.vc_mask,
                label: item.vc_mask,
              })),
            ]}
          />
        </div>
      </div>
      <TotalAudience />
    </div>
  );
};

GeneralData.propTypes = {
  step: PropTypes.number,
};

export default GeneralData;
